import axios from './axios';

export const requestProjectFeedback = ({ id, data }) => axios.post(`projects/${id}/feedback/request`, data);
export const getProjectFeedback = ({ id, params }) => axios.get(`projects/${id}/feedback`, { params });
export const downloadProjectFeedback = ({ projectId, feedbackId }) => axios.get(`projects/${projectId}/feedback/${feedbackId}/download`, { responseType: 'blob' });
